export const cx = makeCls;

export default function makeCls(...inputs) {
    const inp = Array.isArray(inputs[0]) ? inputs[0] : [...inputs];
    return inp.filter(Boolean).join(' ');
}